// extracted by mini-css-extract-plugin
module.exports = {"card":"marketing-card_card__Bpz7b","image":"marketing-card_image__KGeNm","desktopImage":"marketing-card_desktopImage__SByRH","mobileImage":"marketing-card_mobileImage__tsU_W"};